/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_License_LabelInputs */

const en_marketing_license_label = /** @type {(inputs: Marketing_License_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The template`)
};

const es_marketing_license_label = /** @type {(inputs: Marketing_License_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La plantilla`)
};

const fr_marketing_license_label = /** @type {(inputs: Marketing_License_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le modèle`)
};

/**
* | output |
* | --- |
* | "The template" |
*
* @param {Marketing_License_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_license_label = /** @type {((inputs?: Marketing_License_LabelInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_License_LabelInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_license_label(inputs)
	if (locale === "es") return es_marketing_license_label(inputs)
	return fr_marketing_license_label(inputs)
});